<template>
    <icon-base v-bind="$props">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20v-1a6 6 0 0 1 6 -6h4a6 6 0 0 1 6 6v1" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
